import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { cameraDelete } from '../../../redux/api/cameraAPI';
import Button from '../../ui/button';
import { useTranslation } from 'react-i18next';

const DeleteCameraModal = ({ isOpen, onClose, data }) => {
    const {t} = useTranslation('common');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const closeModal = (refresh = false) => {
        if (loading) return;
        setError(null);
        onClose(refresh);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const camerasToDelete = Array.isArray(data) ? data : [data.Camera_ID];

            if (camerasToDelete.length === 0) {
                setLoading(false);
                closeModal();
                return;
            }

            const isBulkDelete = camerasToDelete.length > 1;

            const results = await Promise.all(
                camerasToDelete.map(id => cameraDelete(id, { skipSuccessToast: isBulkDelete }))
            );

            const errors = results
                .filter(result => result.error)
                .map(result => result.error);

            const successCount = camerasToDelete.length - errors.length;
            if (isBulkDelete && successCount > 0) {
                toast.success(`${successCount} camera(s) successfully deleted.`);
            }

            if (errors.length > 0) {
                setError(errors.join(', '));
                if (errors.length < camerasToDelete.length) {
                    onClose(true);
                }
            } else {
                closeModal(true);
            }
        } catch (err) {
            console.error("Error Deleting Camera(s):", err);
            setError("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) {
        return null;
    }

    const isBulk = Array.isArray(data);
    const count = isBulk ? data.length : 1;
    const cameraName = !isBulk && data ? data.Name : '';

    return (
        <div className="grid space-y-4 w-auto m-2 bg-white p-8 rounded-3xl shadow-lg">
            <p className="text-center text-xl text-[#4C4C66] font-bold">{t('delete_confirmation')}</p>
            <p className="text-center text-md text-[#4C4C66] font-normal">
                {isBulk
                    ? `Are you sure you want to delete ${count} cameras?`
                    : `${t('are_you_sure_that_you_want_to_delete_this_camera')} ${cameraName}?`
                }
            </p>
            {error && (
                <p className="text-center text-red-500 bg-red-100 p-2 rounded-md">{error}</p>
            )}
            <div className='flex justify-center pt-4 space-x-5'>
                <Button onClick={() => closeModal()} size="large" color="cancel" disabled={loading}>
                    {t('cancel')}
                </Button>
                <Button onClick={handleSubmit} type="submit" size="large" disabled={loading}>
                    {loading ? t('deleting') : t('delete')}
                </Button>
            </div>
        </div>
    );
};

export default DeleteCameraModal;
